import { Box } from "@mui/material";
import React from "react";

export const ServiceHistoryPage = () => {
  return <Box>ServiceHistoryPage</Box>;
};
